const MIN_PHONE_DIGITS = 10;
const PHONE_DIGITS_RE = /^[0-9]+$/;

const isValidPhone = (value) => {
  const digits = value.trim();
  return PHONE_DIGITS_RE.test(digits) && digits.length >= MIN_PHONE_DIGITS;
};

const initContactForm = () => {
  const form = document.getElementById('contact_form');
  const phone = document.getElementById('ContactForm-phone');
  if (!form || !phone || form.dataset.contactFormInit) return;

  form.dataset.contactFormInit = 'true';

  const invalidMessage = phone.getAttribute('title') || 'Enter a valid phone number.';

  const validatePhone = () => {
    const valid = isValidPhone(phone.value);
    phone.setCustomValidity(valid ? '' : invalidMessage);
    return valid;
  };

  phone.addEventListener('input', () => {
    const digitsOnly = phone.value.replace(/\D/g, '');
    if (digitsOnly !== phone.value) {
      phone.value = digitsOnly;
    }
    validatePhone();
  });

  phone.addEventListener('blur', validatePhone);

  form.addEventListener('submit', (event) => {
    if (!validatePhone()) {
      event.preventDefault();
      phone.reportValidity();
    }
  });
};

export default initContactForm;
